import { Routes } from '@angular/router';
import { LayoutComponent } from './app/layout/component/layout/layout.component';
import { DashComponent } from './app/pages/dash/dash.component';
import { HistoryComponent } from './app/pages/history/history.component';
import { SubscriptionComponent } from './app/pages/subscription/subscription.component';
import { ProfilComponent } from './app/pages/profil/profil.component';
import { DetailsComponent } from './app/pages/details/details.component';
import { BankrollComponent } from './app/pages/bankroll/bankroll.component';
import { LoginComponent } from './app/pages/authentification/login/login.component';
import { RegisterComponent } from './app/pages/authentification/register/register.component';
import { authGuard } from './app/guards/auth.guard';
import { predictionGuard } from './app/guards/prediction.guard';
import { profileGuard } from './app/guards/profile.guard';
import { historyGuard } from './app/guards/history.guard';
import { detailsGuard } from './app/guards/predictionDetails.guard';
import { UserProfileComponent } from './app/pages/profil/components/user-profile/user-profile.component';
import { NotificationsProfileComponent } from './app/pages/profil/components/notifications-profile/notifications-profile.component';
import { SubscriptionsProfileComponent } from './app/pages/profil/components/subscriptions-profile/subscriptions-profile.component';
import { InvestmentComponent } from './app/pages/investment/investment.component';
import { ManagePredictionsComponent } from './app/pages/admin/manage-predictions/manage-predictions.component';
import { predictionAdminGuard } from './app/guards/prediction_admin.guard';
import { ManageTeamsComponent } from './app/pages/admin/manage-teams/manage-teams.component';
import { teamsAdminGuard } from './app/guards/teams_admin.guard';
import { UnitPredictionComponent } from './app/pages/admin/unit-prediction/unit-prediction.component';
import { EditPredictionComponent } from './app/pages/admin/manage-predictions/edit-prediction/edit-prediction.component';
import { ManageProjectsComponent } from './app/pages/admin/manage-projects/manage-projects.component';
import { VerifyEmailComponent } from './app/pages/authentification/verify-email/verify-email.component';
import { ConfirmEmailComponent } from './app/pages/authentification/confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './app/pages/authentification/reset-password/reset-password.component';
import { ManageNotificationsComponent } from './app/pages/admin/manage-notifications/manage-notifications.component';
import { FormationsComponent } from './app/src/app/pages/formations/formations.component';
import { ManageFormationsComponent } from './app/src/app/pages/manage-formations/manage-formations.component';
import { EditFormationComponent } from './app/src/app/src/app/pages/manage-formations/edit-formation/edit-formation.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', component: DashComponent, canActivate: [predictionGuard] },
            { path: 'historique', component: HistoryComponent, canActivate: [historyGuard] },

            { path: 'abonnement', component: SubscriptionComponent, canActivate: [profileGuard] },
            { path: 'profil', component: ProfilComponent, canActivate: [profileGuard] },
            {
                path: 'investissement',
                component: InvestmentComponent
            },
            { path: 'bankroll', component: BankrollComponent },
            {
                path: 'formations', component: FormationsComponent, canActivate: [predictionGuard]
            },
            { path: 'details/:id', component: DetailsComponent, canActivate: [detailsGuard] },

        ]
    },
    {
        path: 'profile',
        component: LayoutComponent,
        children: [
            {
                path: 'compte', component: UserProfileComponent
            },
            {
                path: 'notifications', component: NotificationsProfileComponent
            },
            {
                path: 'subscriptions', component: SubscriptionsProfileComponent
            },
        ]
    },
    {
        path: 'admin',
        component: LayoutComponent,
        canActivate: [predictionAdminGuard],
        children: [
            {
                path: 'prediction', component: ManagePredictionsComponent, canActivate: [predictionAdminGuard]
            },
            {
                path: 'prediction/:id/edit', component: EditPredictionComponent, canActivate: [detailsGuard]
            },
            {
                path: 'teams', component: ManageTeamsComponent, canActivate: [teamsAdminGuard]
            },
            {
                path: 'unit-prediction', component: UnitPredictionComponent
            },
            {
                path: 'formations', component: ManageFormationsComponent, canActivate: [predictionGuard]
            },
            {
                path: 'formations/:id/edit', component: EditFormationComponent, canActivate: [detailsGuard, predictionGuard]
            },
            {
                path: 'projects', component: ManageProjectsComponent
            },
            {
                path: 'notifications', component: ManageNotificationsComponent
            }
        ]
    },
    {
        path: 'auth',
        children: [
            { path: 'login', component: LoginComponent },
            { path: 'register', component: RegisterComponent },
            {
                path: 'verify-email', component: VerifyEmailComponent
            },
            {
                path: 'confirm-email', component: ConfirmEmailComponent
            },
            {
                path: 'reset-password', component: ResetPasswordComponent
            }

        ]
    },
    { path: '**', redirectTo: '/' }

];
